import { RootState } from '../store';

// eslint-disable-next-line import/prefer-default-export
export const openBatchProcessSelector = (state: RootState) => state.batchMenu.anchorEl;
export const forceRenderSelector = (state: RootState) => state.batchMenu.forceRender;
